import { ViewLOSV2EventManagePage } from "./ViewLOSV2EventManagePage";

export default ViewLOSV2EventManagePage;
